import React, { ReactNode } from "react";
import * as microsoftTeams from "@microsoft/teams-js";
import {
    Flex,
    Button,
    ButtonProps,
    CallIcon,
    CallVideoIcon,
    ChatIcon,
    EmailIcon,
    MeetingNewIcon,
} from "@fluentui/react-northstar";

export interface AadUserContactButtonsProps {
    email?: string;
    phoneNumber?: string;
    hasMobileDeviceCapabilities?: boolean;
    userFoundInAad?: boolean;
    centered?: boolean;
}

export const AadUserContactButtons: React.FC<AadUserContactButtonsProps> = ({
    email,
    phoneNumber,
    hasMobileDeviceCapabilities,
    userFoundInAad,
    centered,
}) => {
    const buttons: ReactNode[] = [];
    const commonButtonProps: ButtonProps = {
        iconOnly: true,
        text: true,
    };

    if (phoneNumber && hasMobileDeviceCapabilities) {
        buttons.push(
            <Button
                {...commonButtonProps}
                key="call"
                icon={<CallIcon />}
                title="Zadzwoń na telefon"
                onClick={() => window.open(`tel:${phoneNumber}`)}
            />
        );
    }

    if (email) {
        buttons.push(
            <Button
                {...commonButtonProps}
                key="email"
                icon={<EmailIcon />}
                title="Wyślij wiadomość email"
                onClick={() => window.open(`mailto:${email}`)}
            />
        );
    }

    if (email && userFoundInAad) {
        buttons.push(
            <Button
                {...commonButtonProps}
                key="video"
                icon={<CallVideoIcon />}
                title="Zadzwoń na Microsoft Teams"
                onClick={() => microsoftTeams.call.startCall({ targets: [email] })}
            />
        );
        buttons.push(
            <Button
                {...commonButtonProps}
                key="chat"
                icon={<ChatIcon />}
                title="Wyślij wiadomość na Microsoft Teams"
                onClick={() => microsoftTeams.chat.openChat({ user: email })}
            />
        );
        buttons.push(
            <Button
                {...commonButtonProps}
                key="meeting"
                icon={<MeetingNewIcon />}
                title="Zorganizuj spotkanie"
                onClick={() =>
                    microsoftTeams.app.openLink(`https://teams.microsoft.com/l/meeting/new?attendees=${email}`)
                }
            />
        );
    }

    return <Flex hAlign={centered ? "center" : undefined}>{buttons}</Flex>;
};
